<template>
<div class="product-module__recommended__group" v-if="title && products && products.length > 0">
    <div class="columns product-module__recommended__group__title">
        <div class="column">
            <h2 class="title is-3">{{title}}</h2>
        </div>
        <div class="column is-narrow">
            <button @click.prevent="$refs.carousel.goToPrev()" class="product-module__recommended__group__title__button">
                <span class="is-block">←</span>
                <span class="is-block">←</span>
            </button>
            <i></i>
            <button @click.prevent="$refs.carousel.goToNext()" class="product-module__recommended__group__title__button">
                <span class="is-block">→</span>
                <span class="is-block">→</span>
            </button>
        </div>
    </div>
    <agile ref="carousel" class="special-products" :options="aglie_opt2">
        <ProductTile :class="'column slide is-' + 3" v-for="item, i in products" :product="item" :key="i" />
    </agile>
</div>
</template>

<script>
import { VueAgile } from 'vue-agile';
import ProductTile from './elements/ProductTile';
export default {
    name        :   'ProductGroup',
    props       :   ['title', 'products'],
    components  :   {
        ProductTile :   ProductTile,
        agile       :   VueAgile
    },
    data()
    {
        return {
            aglie_opt2  :   {
                slidesToShow: 2,
                autoplay: false,
                autoplaySpeed: 5000,
                navButtons: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/ProductGroup.vue